import { CreateParams, UpdateParams } from 'react-admin';

import httpClient from '@app/config/clients/http';

type ImgResourceType = {
  id: string;
  jsonKey: string;
  imageKeys: string[];
};

export const enum CREATE_UPDATE_TYPES {
  PUT = 'PUT',
  POST = 'POST',
}

export const imageResources = [
  { id: 'experts', jsonKey: 'expert', imageKeys: ['logo'] },
  { id: 'companies', jsonKey: 'company', imageKeys: ['logo'] },
  { id: 'media', jsonKey: 'media', imageKeys: ['logo'] },
  { id: 'series', jsonKey: 'series', imageKeys: ['logo'] },
  { id: 'ctas', jsonKey: 'cta', imageKeys: ['cta_image'] },
  { id: 'events', jsonKey: 'event', imageKeys: ['sponsor', 'logo'] },
];

export const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const createFormData = async (imgResource: ImgResourceType, params: CreateParams | UpdateParams) => {
  const formData = new FormData();
  formData.append(imgResource?.jsonKey as string, JSON.stringify(params.data));
  if (imgResource?.imageKeys.length > 1) {
    imgResource?.imageKeys.forEach((key) => {
      formData.append(key as string, params.data[key] as string);
    });
  } else {
    //If it only has one key, should take the first and only one of the array
    const firstImageKey = imgResource?.imageKeys[0];

    formData.append(firstImageKey, params.data[firstImageKey] as string);
  }

  return formData;
};

export const saveResourceWithMultipartData = async (
  imgResource: ImgResourceType,
  method: CREATE_UPDATE_TYPES,
  resource: string,
  params: CreateParams | UpdateParams
) => {
  const formData = await createFormData(imgResource, params);
  const baseUrl = `${window.ENV.API_URL}/${resource}`;
  const currentUrl = method === CREATE_UPDATE_TYPES.POST ? baseUrl : `${baseUrl}/${params.data.id}`;

  return httpClient(currentUrl, {
    method,
    headers: new Headers({
      Accept: '*/*',
    }),
    body: formData,
  }).then(({ json }) => ({
    data: { ...params.data, id: json.id },
  }));
};
